import * as Yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum K1893PalletInstructionsLineItemKeys {
  itemNumber = 'itemNumber',
  description = 'description',
  eaUPC = 'eaUPC',
  unitsPerPack = 'unitsPerPack',
  packSize = 'packSize',
  caseSize = 'caseSize',
  caseQtyOrdered = 'caseQtyOrdered',
  totalPacks = 'totalPacks',
  totalUnits = 'totalUnits',
}

const K1893PalletInstructionsLineItemSchema = Yup.object().shape({
  [K1893PalletInstructionsLineItemKeys.itemNumber]: Yup.number().nullable().optional(),
  [K1893PalletInstructionsLineItemKeys.description]: Yup.string().nullable().optional(),
  [K1893PalletInstructionsLineItemKeys.eaUPC]: Yup.string().nullable().optional(),
  [K1893PalletInstructionsLineItemKeys.unitsPerPack]: Yup.string().nullable().optional(),
  [K1893PalletInstructionsLineItemKeys.packSize]: Yup.string().nullable().optional(),
  [K1893PalletInstructionsLineItemKeys.caseSize]: Yup.string().nullable().optional(),
  [K1893PalletInstructionsLineItemKeys.caseQtyOrdered]: Yup.string().nullable().optional(),
  [K1893PalletInstructionsLineItemKeys.totalPacks]: Yup.string().nullable().optional(),
  [K1893PalletInstructionsLineItemKeys.totalUnits]: Yup.string().nullable().optional(),
})

export const K1893PalletInstructionsFileDataSchema = Yup.object().shape({
  buyer: Yup.object()
    .shape({
      companyName: Yup.string().nullable().optional(),
      addressLine1: Yup.string().nullable().optional(),
      phoneNumber: Yup.string().nullable().optional(),
      emailAddress: Yup.string().nullable().optional(),
    })
    .required(),
  vendor: Yup.object()
    .shape({
      companyName: Yup.string().nullable().optional(),
      addressLine1: Yup.string().nullable().optional(),
      phoneNumber: Yup.string().nullable().optional(),
      emailAddress: Yup.string().nullable().optional(),
    })
    .required(),
  purchaseOrderNumber: Yup.string().nullable().optional(),
  dateIssued: Yup.string().nullable().optional(),
  dueDate: Yup.string().nullable().optional(),
  dateReady: Yup.string().nullable().optional(),
  paymentTerms: Yup.string().nullable().optional(),
  freightTerms: Yup.string().nullable().optional(),
  destination: Yup.object()
    .shape({
      appointmentRequired: Yup.string().nullable().optional(),
      company: Yup.string().nullable().optional(),
      addressLine1: Yup.string().nullable().optional(),
      contactName: Yup.string().nullable().optional(),
      contactEmail: Yup.string().nullable().optional(),
      contactPhone: Yup.string().nullable().optional(),
    })
    .required(),
  items: Yup.array().of(K1893PalletInstructionsLineItemSchema).required(),
  instructionsHeader: Yup.string().nullable().optional(),
  comments: Yup.string().nullable().optional(),
})

export type K1893PalletInstructionsFileData = Yup.InferType<
  typeof K1893PalletInstructionsFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<K1893PalletInstructionsFileData>

export const k1893PalletInstructionsFileMappings: RequiredFileData = {
  buyer: {
    companyName: 'f1eb6524-ba25-473b-8223-088af1c9d53b',
    addressLine1: '8a2e6866-5b8f-494a-be4b-87b4ee0ba327',
    phoneNumber: 'ed71c996-c852-4b9f-9ee4-8e869cf49cc6',
    emailAddress: 'f71b7fc2-5a83-48ec-a440-9a48fab2ef54',
  },
  vendor: {
    companyName: 'aaab694b-9fbf-4f3f-9e85-79b6838a70b6',
    addressLine1: '8f645058-3f4f-4eff-80d5-86e6785fab49',
    phoneNumber: '6620c3b3-7173-41f6-af98-3edb478c5c77',
    emailAddress: '2ef5fa98-78d7-47c2-b2f5-492d9f3a2156',
  },
  purchaseOrderNumber: '6ef29245-e3f9-48e2-98cb-058693016b0f',
  paymentTerms: '335f3217-4956-4c17-83e8-2557e1d7f1e3',
  freightTerms: 'bf99fc73-af67-46b7-b6c4-470d6f5bb5ad',
  dateIssued: '16f3a031-a2d9-4f5f-9b10-8fa8529ed441',
  dueDate: '4a63fe29-031b-47d2-b524-63f66cb9cf0b',
  dateReady: '145224f1-0ee9-42b6-9e46-e67dc8302fbf',
  destination: {
    appointmentRequired: 'c325f053-fe50-4577-ac9a-07e178e490c8',
    company: '2ece5aa5-80e4-4cc0-9d98-b90e5298d179',
    addressLine1: '55183d8d-9ade-4c4e-9f8f-8cc14dc872f3',
    contactName: 'da4b0db9-7a5a-4519-9995-6e00303925ac',
    contactEmail: '09ef259a-91df-4165-b623-084bf7f2fedd',
    contactPhone: 'e094d94f-8273-40cd-a113-a877ae2ef076',
  },
  instructionsHeader: 'be4ac36b-6ae1-4fcd-8e72-ec0418bde15f',
  comments: 'b8b998be-829a-41be-ba7c-f89cc6d1838f',
  items: [
    {
      itemNumber: null,
      description: '404d3196-6e45-45b4-b2c0-fc4dadd8ea3a',
      unitsPerPack: '0e595278-d080-42cc-95ef-62e02741c747',
      eaUPC: '389e31b8-752e-413d-bc84-f66b93bb0f63',
      packSize: '2b44bd69-05bd-4247-a218-c9493c7ca4bc',
      totalPacks: 'c6241656-6dc6-46fd-8dcc-b0c16f2bb4dc',
      caseSize: '79967d3e-52dd-4d8e-9221-66535d7fcdb7',
      caseQtyOrdered: 'e1e4101a-9bc3-4db7-bb4a-dbdb87d7f536',
      totalUnits: '2e81b37f-680c-4914-a468-3a154805723f',
    },
  ],
}
